export default "__VITE_ASSET__Dan50SV1__"